import { render, staticRenderFns } from "./CreateChooser.vue?vue&type=template&id=1f809244&"
import script from "./CreateChooser.vue?vue&type=script&lang=js&"
export * from "./CreateChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f809244')) {
      api.createRecord('1f809244', component.options)
    } else {
      api.reload('1f809244', component.options)
    }
    module.hot.accept("./CreateChooser.vue?vue&type=template&id=1f809244&", function () {
      api.rerender('1f809244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/calendar/CreateChooser.vue"
export default component.exports